export default function DSA_Binary_Search() {
  return <div>DSA_Binary_Search Component</div>;
}
